import React, {useEffect, useState} from "react";
import Preloader from "../common/Preloader/Preloader";
import {useHistory, useLocation} from "react-router-dom";
import {themeButtons} from "../../css/themeButtons";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {useQuery} from "../common/CustomHook/useQuery";





const ConfirmAccount = (props) => {
    const {confirmRegistration, userIsAuth} = props

    const query = useQuery();
    let confirmCode = query.get("confirmCode")
    let id = query.get("id")

    const [confirmMessage, setConfirmMessage] = useState()

    const history = useHistory()
    const redirectToProfile = () => {
        history.push('/lk')
    }

    useEffect(async () => {
        let res = await confirmRegistration({id, confirmCode})
        if (res.status) {
            setConfirmMessage('Поздравляем! Ваш аккаунт успешно подтвержден')
        } else {
            setConfirmMessage(res.data.message)
        }

    }, [])



    const [ticks, setTicks] = useState(10);


    useEffect(() => {
        let timer = setTimeout(() => {
            setTicks(ticks - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [ticks]);


    useEffect(() => {
        let timer = null

        timer = setTimeout(() => {
            redirectToProfile()
        }, 10000);


        return () => clearTimeout(timer);
    }, [userIsAuth]);




    const buttons = themeButtons();
    if(!confirmMessage) {
        return <Preloader loading={true} text="Подтверждение аккаунта..."/>
    }
    return (
        <div className="main ps-0">
            <div className="container-fluid">
                <div className="w-100 mt-5 text-center">
                    <h5 className="mb-3">{confirmMessage}</h5>
                    <Typography className="mb-2" variant="body2" display="block">
                        Нажмите продолжить или подождите и
                        через {ticks} {ticks >= 5 ? "секунд" : ticks > 1 ? "секунды" : "секунду"} мы
                        перенаправим Вас в личный кабинет
                    </Typography>
                    <Button className={`btn ${buttons.btnGreen}`} onClick={redirectToProfile}
                            variant="contained">Перейти в личный кабинет</Button>

                </div>

            </div>
        </div>
    )


}


export default ConfirmAccount